<template>
  <div class="modal fade"
       id="addUpdateBaykedExclusiveDeal"
       tabindex="-1"
       data-backdrop="static"
       role="dialog"
       aria-labelledby="myModalLabel"
  >
    <div class="modal-dialog"
         role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close">
            <span aria-hidden="true">
              &times;
            </span>
          </button>
          <h4 class="modal-title"
          >
            Add / Update Bebambi Exclusive Deal: {{baykedExclusiveDeal.menuItemsByMenuItemId.name}}
          </h4>
        </div>
        <form method="post"
              @submit.prevent="addUpdateBaykedExclusiveDeal()"
        >
          <div class="modal-body">
            <div class="row">
              <div class="form-group">
                <label>
                  Warehouse
                </label>
                <multiselect
                    id="restaurant"
                    v-model="selectedRestaurant"
                    :options="allRestaurants"
                    label="name"
                    :disabled="updateDeal"
                    track-by="name"
                    @close="bindSelectedRestaurantToFetchBranches()"/>
              </div>
            </div>

            <div class="row">
              <div class="form-group">
                <label>
                  Vendor
                  <b v-if="selectedRestaurant === ''"
                     class="text-danger text-sm"
                  >
                    (select warehouse first)
                  </b>
                </label>

                <select v-model="baykedExclusiveDeal.branchesByBranchId.id"
                        class="form-control styleSelectElement"
                        :disabled="selectedRestaurant === '' || updateDeal"
                        @change="fetchBranchMenuItemsOfBaykedExclusiveCategory">

                  <option value=""
                  >
                    Select Vendor
                  </option>
                  <option v-for="branch in allBranches"
                          :value="branch.id"
                  >
                    {{branch.areasByAreaId.name}}
                  </option>
                </select>
              </div>
            </div>

            <div class="row">
              <div class="form-group">
                <label :class="(baykedExclusiveDeal.menuItemsByMenuItemId.id !== '') ? 'col-md-3' : ''">
                  Menu Items
                  <b v-if="baykedExclusiveDeal.branchesByBranchId.id === ''"
                     class="text-danger text-sm"
                  >
                    (select vendor first)
                  </b>
                </label>

                <div v-if="baykedExclusiveDeal.menuItemsByMenuItemId.id !== ''" class="col-md-5">
                  <div class="checkbox">
                    <label>
                      <input type="checkbox"
                             v-model="baykedExclusiveDeal.foreverDeal"
                             @click="baykedExclusiveDeal.endDate = (baykedExclusiveDeal.foreverDeal) ? baykedExclusiveDeal.endDate : null"/>
                      mark deal as FOREVER
                    </label>
                  </div>
                </div>
                <select v-model="baykedExclusiveDeal.menuItemsByMenuItemId.id"
                        class="form-control styleSelectElement"
                        :disabled="(baykedExclusiveDeal.branchesByBranchId.id === '' || updateDeal)"
                        @change="fetchBaykedExclusiveDealServings"
                >
                  <option value=""
                  >
                    Select Menu Item
                  </option>
                  <option v-for="menuItem in allMenuItems"
                          :value="menuItem.id"
                          v-if="menuItem.timingConfiguration !== []"
                  >
                    {{menuItem.name}}
                  </option>
                </select>
                <div class="m-t-md" v-if="baykedExclusiveDeal.menuItemsByMenuItemId.description">
                  <label>Menu Items Description</label>
                  <textarea cols="73" rows="2" class="width-100" disabled="disabled" charswidth="23" v-model="baykedExclusiveDeal.menuItemsByMenuItemId.description" name="text_body"></textarea>
                </div>
                <div v-else>
                  <label class="text-danger text-sm" v-if="baykedExclusiveDeal.menuItemsByMenuItemId.id !== ''">
                    <i>No Menu Item Description</i>
                  </label>
                </div>
                <div v-else>
                  <label class="text-danger text-sm" v-if="baykedExclusiveDeal.menuItemsByMenuItemId.id !== ''">
                    <i>No Menu Item Description</i>
                  </label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 form-group">
                <label>Start date</label>
                <div class='input-group start_date'
                     id='datepicker'
                >
                  <input type='text'
                         class="form-control"
                         :readonly="true"
                         :disabled="(baykedExclusiveDeal.menuItemsByMenuItemId.id === '')"
                         v-model="baykedExclusiveDeal.startDate"
                         placeholder="Enter Start date"/>
                  <span class="input-group-addon">
                    <span class="glyphicon glyphicon-calendar">
                    </span>
                  </span>
                </div>
              </div>

              <div class="col-md-6 form-group">
                <label>End date
                <b v-if="baykedExclusiveDeal.startDate === '' && baykedExclusiveDeal.menuItemsByMenuItemId.id !== ''"
                   class="text-danger text-sm"
                >
                  (select start date first)
                </b>
                </label>
                <div class='input-group end_date'
                     id='datepicker'
                >
                  <input type='text'
                         class="form-control"
                         :readonly="true"
                         :disabled="(baykedExclusiveDeal.menuItemsByMenuItemId.id === '' || baykedExclusiveDeal.startDate === '' || baykedExclusiveDeal.foreverDeal)"
                         v-model="baykedExclusiveDeal.endDate"
                         placeholder="Enter end date"/>
                  <span class="input-group-addon">
                    <span class="glyphicon glyphicon-calendar">
                    </span>
                  </span>
                </div>
              </div>
            </div>

            <a @click="fetchBranchTiming()" :title="baykedExclusiveDeal.menuItemsByMenuItemId.id !== '' ? 'Copy branch timing' : 'Select menu item to Copy branch timing'" class="copy-branch-timing">
              <i class="fa fa-plus" aria-hidden="true"></i>
            </a>
            <TimingsComponent ref="timingComponent"
                              :label="'Bebambi Deal Timings'"
                              :update-timing-configuration="baykedExclusiveDeal.timingConfiguration"
                              :is-deal="true"/>

            <DealServingsSavingCost v-if="baykedExclusiveDeal.menuItemsByMenuItemId.menuItemTypesById"
              :deal-servings="baykedExclusiveDeal.menuItemsByMenuItemId.menuItemTypesById"
              @update:servingsSavingCost =" (event) => baykedExclusiveDeal.menuItemsByMenuItemId.menuItemTypesById = event"
              />

          </div>
          <div class="modal-footer">
            <button v-if="updateDeal"
                    type="button"
                    :class="(baykedExclusiveDeal.deleted ? 'btn btn-success' : 'btn btn-danger')"
                    @click="toggleDealItem()"
            >
              {{(baykedExclusiveDeal.deleted) ? 'Enable Deal' : 'Disable Deal'}}
            </button>
            <button type="button"
                    class="btn btn-default"
                    data-dismiss="modal"
            >
              Close
            </button>
            <button type="submit"
                    class="btn btn-primary"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getAllBranchesOfRestaurant,
  getAllRestaurant,
  toggleMenuItemById
} from "../../api/restaurants";
import Multiselect from "vue-multiselect";
import moment from "moment";
import TimingsComponent from "../utils/TimingsComponent";
import DealServingsSavingCost from "../BaykedExclusiveDeals/DealServingsSavingCost";
import {
  addUpdateBranchExclusiveDeal,
  getBaykedDealDetailsById,
  getBranchExclusiveDeals, getBranchTiming,
  getDealServings
} from "../../api/baykedExclusiveDeals";

export default {
  name: "AddUpdateBaykedExclusiveDeal",
  components: {
    DealServingsSavingCost,
    TimingsComponent,
    Multiselect
  },
  data() {
    return {
      baykedExclusiveDeal: {
        "menuItemsByMenuItemId": {
          "id": '',
          "name": '',
          "deleted": false,
          "menuItemTypesById": []
        },
        "menuItemName": '',
        "deleted": false,
        "branchesByBranchId" :{
          "id": '',
          "areasByAreaId": {
            "id": '',
            "name": ''
          },
          "restaurantsByRestaurantId": {
            "id": '',
            "name": ''
          }
        },
        "branchName": '',
        "restaurantId": 0,
        "restaurantName": '',
        "startDate" : '',
        "endDate": null,
        "foreverDeal" : false,
        "timingConfiguration" : [],
      },
      allRestaurants: [],
      allBranches: [],
      allMenuItems: [],
      selectedRestaurant: '',
      updateDeal: false,
      dateFormat: "YYYY-MM-DD",
    }
  },
  mounted: function () {
    this.jQueryForStartDate();
    this.jQueryForEndDate();
    $("#addUpdateBaykedExclusiveDeal").on('hidden.bs.modal',  (e) => {
      this.resetData();
    });
  },
  methods: {
    load: async function (isNewDeal, baykedDealId) {
      this.updateDeal = !isNewDeal;
      if (isNewDeal) {
        let allRestaurantsResp = await getAllRestaurant();
        this.allRestaurants = (allRestaurantsResp.data !== null) ? allRestaurantsResp.data : [];
      }else{
        await this.fetchBaykedExclusiveDealDetails(baykedDealId);
      }
      $("#addUpdateBaykedExclusiveDeal").modal("show");
    },
    jQueryForEndDate: function(){
      let self= this;
      let endDatePicker = $('.end_date');
      endDatePicker.daterangepicker({
        format: self.dateFormat,
        singleDatePicker: true,
        showDropdowns: true,
        minYear: 1950,
        maxYear: parseInt(moment().format('YYYY'), 0),
        minDate: self.baykedExclusiveDeal.startDate
      }).on('apply.daterangepicker', function(ev, picker) {
        self.baykedExclusiveDeal.endDate = picker.startDate.format(self.dateFormat);
      });

    },
    jQueryForStartDate: function (){
      let self= this;
      let startDatePicker = $('.start_date');
      startDatePicker.daterangepicker({
        format: self.dateFormat,
        singleDatePicker: true,
        showDropdowns: true,
        minYear: 1950,
        minDate: new Date(),
        maxYear: parseInt(moment().format('YYYY'), 0),
      }).on('apply.daterangepicker', function(ev, picker) {
        self.baykedExclusiveDeal.startDate = picker.startDate.format(self.dateFormat);
        self.jQueryForEndDate();
      });
    },
    validateBaykedDealConfig: function (){
      let deal = this.baykedExclusiveDeal;
      if((deal.menuItemsByMenuItemId.id === '') || (deal.branchesByBranchId.id === '') || this.selectedRestaurant === ''){
        swal("Error!", "Please enter valid information!", "error");
        return false;
      }if(deal.foreverDeal && deal.startDate === ''){
        swal("Error!", "Please select START date!", "error");
        return false;
      }if((!deal.foreverDeal) && ((deal.endDate === null) || (deal.startDate > deal.endDate))){
        swal("Error!", "Please select valid START and END date!", "error");
        return false;
      }
      return true;
    },
    addUpdateBaykedExclusiveDeal: async function () {
      this.showLoading();
      if( this.baykedExclusiveDeal.menuItemsByMenuItemId.menuItemTypesById.length > 0 && $("#saving_cost").is(":invalid") ){
        swal("TRY AGAIN", "Invalid Saving Cost!", "error");
        Swal.close();
        return;
      }
      let timings= this.$refs.timingComponent.updateBranchTimings();
      if(!this.validateBaykedDealConfig() || timings.length === 0){
        return;
      }
      this.baykedExclusiveDeal.timingConfiguration = JSON.stringify(timings);
      this.baykedExclusiveDeal.restaurantId = this.selectedRestaurant.id;
      this.baykedExclusiveDeal.restaurantName = this.selectedRestaurant.name;
      let branchName = this.allBranches.find( branches => branches.id === this.baykedExclusiveDeal.branchesByBranchId.id).areasByAreaId.name;
      let menuItem = this.allMenuItems.find( menuItems => menuItems.id === this.baykedExclusiveDeal.menuItemsByMenuItemId.id);

      this.baykedExclusiveDeal.branchName = branchName;
      this.baykedExclusiveDeal.menuItemName = menuItem.name;
      let params = new URLSearchParams();
      params.append("baykedExclusiveDeal", JSON.stringify(this.baykedExclusiveDeal));
      let addUpdateExclusiveDealResp = await addUpdateBranchExclusiveDeal(params);
      if(addUpdateExclusiveDealResp){
        swal("SUCCESS!", "Successfully Save Bebambi Exclusive Deal!", "success");
        $("#addUpdateBaykedExclusiveDeal").modal("hide");
        await this.$parent.dataTable.ajax.reload(null, false);
      } else {
        swal("Error!", "Error while Saving Bebambi Exclusive Deal!", "error");
      }
    },
    bindSelectedRestaurantToFetchBranches: async function () {
      if(this.selectedRestaurant !== '') {
        let params = new URLSearchParams();
        params.append("restaurant_id", this.selectedRestaurant.id);
        let restaurantAllBranch = await getAllBranchesOfRestaurant(params);
        this.allBranches = (restaurantAllBranch.data !== null) ? restaurantAllBranch.data : [];
      }
    },
    fetchBranchMenuItemsOfBaykedExclusiveCategory: async function () {
      let branchMenuItemsResp = await getBranchExclusiveDeals(this.baykedExclusiveDeal.branchesByBranchId.id).catch( ex => {
        this.showErrorMessage(ex)
      });
      this.allMenuItems = (branchMenuItemsResp.data !== null) ? branchMenuItemsResp.data : [];
    },
    fetchBaykedExclusiveDealDetails: async function (deal_id) {
      let baykedDealDetails = await getBaykedDealDetailsById(deal_id);
      if (baykedDealDetails.data !== null) {
        this.baykedExclusiveDeal = baykedDealDetails.data;
        this.baykedExclusiveDeal.timingConfiguration = JSON.parse(this.baykedExclusiveDeal.timingConfiguration);
        this.baykedExclusiveDeal.startDate = moment(this.baykedExclusiveDeal.startDate).format(this.dateFormat);
        this.baykedExclusiveDeal.endDate = (this.baykedExclusiveDeal.endDate === null || this.baykedExclusiveDeal.foreverDeal) ? null : moment(this.baykedExclusiveDeal.endDate).format(this.dateFormat);
        this.allBranches.push(this.baykedExclusiveDeal.branchesByBranchId);
        this.allMenuItems.push(this.baykedExclusiveDeal.menuItemsByMenuItemId);
        this.selectedRestaurant = this.baykedExclusiveDeal.branchesByBranchId.restaurantsByRestaurantId;
        this.jQueryForEndDate();
      }else {
        swal("Error!", "Error while Fetching Bebambi Exclusive Deal of id: " + deal_id + "!", "error");
      }
    },
    fetchBaykedExclusiveDealServings: async function(){
      let dealId = this.baykedExclusiveDeal.menuItemsByMenuItemId.id
      this.baykedExclusiveDeal.menuItemsByMenuItemId.description = this.allMenuItems.find(e => e.id === dealId).description
      let dealsServing = await getDealServings(dealId).catch(ex =>
        this.showErrorMessage(ex)
      );
      if(dealsServing.data.status === 200){
        this.baykedExclusiveDeal.menuItemsByMenuItemId.menuItemTypesById = dealsServing.data.body;
      }else{
        this.showErrorMessage();
      }
    },
    resetData: function () {
      Object.assign(this.$data, this.$options.data.call());
    },
    toggleDealItem: async function () {
      this.showLoading();
      this.baykedExclusiveDeal.deleted = !this.baykedExclusiveDeal.deleted;
      let params = new URLSearchParams();
      params.append("deleted", this.baykedExclusiveDeal.deleted);
      params.append("branch_id", this.baykedExclusiveDeal.branchesByBranchId.id);
      params.append("send_notification", false);

      let toggleDealResp = await toggleMenuItemById(this.baykedExclusiveDeal.menuItemsByMenuItemId.id, params).catch( ex =>{
        this.showErrorMessage(ex)
      });
      if(toggleDealResp.data){
        swal("SUCCESS!", "Successfully" +((this.baykedExclusiveDeal.deleted) ? " Disable" : " Enable") + " Deal!", "success");
      } else {
        swal("Error!", "Error while " + ((this.baykedExclusiveDeal.deleted) ? " Disabling" : " Enabling") +" the Bebambi Exclusive Deal!", "error");
      }
      this.$parent.dataTable.ajax.reload(null, false);
    },
    async fetchBranchTiming() {
      if (!this.baykedExclusiveDeal.menuItemsByMenuItemId.id) {
        return
      }
      let branchId = this.baykedExclusiveDeal.branchesByBranchId.id
      let dealsServing = await getBranchTiming(branchId).catch(ex =>
          this.showErrorMessage(ex)
      );
      this.baykedExclusiveDeal.timingConfiguration = [...[]]
      setTimeout(() => {
        this.baykedExclusiveDeal.timingConfiguration = JSON.parse(JSON.stringify(dealsServing.data));
      }, 100)
    }
  }
}
</script>

<style scoped>
.styleSelectElement {
  height: 40px;
}
.checkbox{
  margin-top: 0;
}
input:invalid {
  border: red solid 3px;
}
textarea {
  resize: vertical;
  min-height: 50px;
  max-height: 135px;
}
.copy-branch-timing {
  margin-right: 403px;
  float: right;
}
.width-100 {
  width: 100%;
}
</style>